import script from "./PageHeader-wap.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader-wap.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__